import { loadConciergeDraft } from '@/components/pricing/conciergeDraft';

/**
 * Check if user has an active concierge intent (either via profile status or localStorage draft).
 * Used in routing to prevent concierge applicants from being funneled into regular membership.
 */
export function hasConciergeIntent(profile: { concierge_status?: string | null } | null | undefined): boolean {
  if (!profile) return false;
  // Profile already marked as concierge applicant
  if (profile.concierge_status === 'pending' || profile.concierge_status === 'submitted') {
    return true;
  }
  return false;
}

export function hasConciergeLocalDraft(): boolean {
  const draft = loadConciergeDraft();
  return !!(draft?.data && draft?.packageId);
}

/**
 * Get the appropriate next route for a user, considering concierge status.
 * Replaces direct `/choose-plan` redirects.
 */
export function getPostVerificationRoute(profile: {
  plan_selected?: boolean | null;
  concierge_status?: string | null;
} | null | undefined): string {
  if (hasConciergeIntent(profile) || hasConciergeLocalDraft()) {
    return '/concierge-submitted';
  }
  return profile?.plan_selected ? '/discover' : '/choose-plan';
}
